import { Box, useTheme, useMediaQuery, Typography, Divider } from "@mui/material";

const steps = [
  {
    number: "1",
    title: "Discover",
    desc: "Understand business needs",
  },
  {
    number: "2",
    title: "Evaluate",
    desc: "Compare DAM platforms",
  },
  {
    number: "3",
    title: "Recommend",
    desc: "Select best-fit solution",
  },
  {
    number: "4",
    title: "Implement",
    desc: "Seamless execution",
  },
  {
    number: "5",
    title: "Optimize",
    desc: "Continuous improvement",
  },
];

export default function OurProcessContainer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box
      sx={{
        maxWidth: "1272px",
        mx: "auto",
        p: 2, // 16px
        borderRadius: "16px",
        border: "1px solid #e0e0e0",
        boxShadow: "0px 4px 4px rgba(0,0,0,0.05)",
        backgroundColor: "#fff",

        display: "flex",
        // alignItems: "center",
        flexDirection: {
          xs: "column",
          md: "row",
        },

        gap: 3, // 24px
      }}
    >
      {steps.map((step, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            // alignItems: "center",
            flex: 1,
          }}
        >
          {/* Item */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1,
              py: 1, // 8px Up & Down
              width: "100%",
            }}
          >
            {/* Number */}

            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "8px",
                border: "1px solid transparent",

                // border gradient
                background:
                  "linear-gradient(#fff,#fff) padding-box, linear-gradient(141.98deg,#FF7FAC,#5834BA) border-box",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "1rem",
                  lineHeight: "150%",
                  letterSpacing: "0.15px",

                  // text's number gradient
                  background: "linear-gradient(141.98deg,#FF7FAC,#5834BA)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {step.number}
              </Typography>
            </Box>

            {/* Title */}
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: "1rem",
                lineHeight: "150%",
                letterSpacing: "0.15px",
              }}
            >
              {step.title}
            </Typography>

            {/* Description */}
            <Typography variant="body2" sx={{ color: "#666666", textAlign: "center" }}>
              {step.desc}
            </Typography>
          </Box>

          {/* Divider (except lat one) */}
          {index !== steps.length - 1 && (
            <Divider
              orientation="vertical"
              orientation={isMobile ? "horizontal" : "vertical"}
              flexItem
              sx={{
                // mx: 2,
                // height: "112px",
                mx: { md: 2 },
                my: { xs: 2, md: 0 },
              }}
            />
          )}
        </Box>
      ))}
    </Box>
  );
}
